import * as Repositories from '../../repositories/repositories'
import {ClientStateContextRepository} from "../../quoteWizard/repositories/clientStateContext.repository";
import {ClientStateContextSearchResultModel, ClientStateContextSearchViewModel} from "./clientstatecontextSearch.viewmodel";
import {ClientStateContext} from "../../quoteWizard/clientstatecontext.model";
import {ClientStateContextSearchCriteria, UserProfile} from "../../models/models";
import {PhoneSearchCriteriaModel} from "../../models/phoneSearchCriteria.model";
import * as Model from "../../models/models";
import * as _ from 'lodash';


export class ClientStateContextSearchGateway {

    static $inject = ['$q', '$log', 'userRepository','clientStateContextRepository','phoneRepository'];

    constructor(private $q: ng.IQService,
                private $log: ng.ILogService,
                private userRepository: Repositories.UserRepository,
                private clientStateContextRepository:ClientStateContextRepository,
                private phoneRepository:Repositories.PhoneRepository
    ) { }

    public loadViewModel(searchCriteria: ClientStateContextSearchCriteria): ng.IPromise<ClientStateContextSearchViewModel> {

        searchCriteria.eventTimeFromLocal = this.convertUtcTimeToLocalTime(searchCriteria.eventTimeFromUtc);
        searchCriteria.eventTimeToLocal = this.convertUtcTimeToLocalTime(searchCriteria.eventTimeToUtc);


        return this.clientStateContextSearch(searchCriteria)
            .then((viewModel:ClientStateContextSearchViewModel)=>{
                return this.setPrimaryContacts(viewModel);
            })
            .then((viewModel:ClientStateContextSearchViewModel)=>{
                return this.setPrimaryContactPhones(viewModel);
            })
            .then((viewModel:ClientStateContextSearchViewModel)=>{
                this.createSearchResults(viewModel);
                return viewModel;
            });
    }

    private clientStateContextSearch (searchCriteria: ClientStateContextSearchCriteria) : ng.IPromise<ClientStateContextSearchViewModel> {

        const viewModel = new ClientStateContextSearchViewModel();

        return this.clientStateContextRepository.clientStateContextSearch(searchCriteria)
            .then((clientStateContext: Array<ClientStateContext>) => {
                viewModel.clientStateContexts = clientStateContext;
                return viewModel;
            });
    }

    private setPrimaryContacts (viewModel:ClientStateContextSearchViewModel) : ng.IPromise<ClientStateContextSearchViewModel> {

        const userIds: Array<string> = <string[]>(_.map(viewModel.clientStateContexts, 'userId'));

        viewModel.primaryContactIds = userIds;

        return this.userRepository.getByIds(userIds)
            .then((users:Array<UserProfile>) =>{
                viewModel.primaryContacts = users;
                return viewModel;
            })

    }

    private setPrimaryContactPhones (viewModel:ClientStateContextSearchViewModel): ng.IPromise<ClientStateContextSearchViewModel>{

        const phoneSearchCriteriaModel = new PhoneSearchCriteriaModel();
        phoneSearchCriteriaModel.userIds = viewModel.primaryContactIds;

        return this.phoneRepository.phoneSearch(phoneSearchCriteriaModel)
            .then((phones:Array<Model.IPhone>)=>{
                viewModel.primaryContactPhones = phones;
               return viewModel;
                }
            )
    }

    private createSearchResults(viewModel:ClientStateContextSearchViewModel): ClientStateContextSearchViewModel{

        let searchResults = [];

        _.forEach(viewModel.primaryContacts, (user:UserProfile)=>{

            let searchResult = new ClientStateContextSearchResultModel();
            searchResult.primaryContactId = user.id;
            searchResult.primaryContactFirstName = user.firstName;
            searchResult.primaryContactLastName = user.lastName;
            searchResult.primaryContactEmail = user.emailAddress;

            let phone = _.find(viewModel.primaryContactPhones,{'userId':user.id});

            if(phone){

                searchResult.primaryContactPhone = phone.phoneNumber;
            }


            let clientStateContext = _.find(viewModel.clientStateContexts, {'userId':user.id});
            searchResult.clientStateContextId = clientStateContext.id;
            searchResult.createdAt = clientStateContext.createdAt;

            searchResults.push(searchResult);
        });

        viewModel.searchResults = searchResults;

        return viewModel;
    }

    private convertUtcTimeToLocalTime = (date: Date): Date => {

        //The BillingStatementLog.CurrentDueDate is a NON Utc DateTime but it is stored in a Date2 field in the database.
        //Therefore the Utc conversion does not need to be applied. This is just a reminder
        return date;

    }

}